export function isNode(node: Object): node is Node {
  return 'nodeType' in node;
}



// WEBPACK FOOTER //
// ../src/type-guards/isNode.ts